export const getWordCompleter = (): { word: string; value: string; meta: string }[] => {
  return [
    { word: 'let', value: 'let', meta: '変数を定義する ' },
    { word: 'const', value: 'const', meta: '定数を定義する ' },
    { word: 'getElementById', value: 'getElementById', meta: 'element ' },
    {
      word: 'querySelector',
      value: 'querySelector',
      meta: 'CSSクエリでエレメントを取得する',
    },
    { word: 'setAttribute', value: 'setAttribute', meta: '属性を設定する' },
    {
      word: 'console.log()',
      value: 'console.log()',
      meta: 'VRコンソールに文字列を出力する',
    },
    {
      word: 'forever(()=>{\n})',
      value: 'forever(()=>{\n})',
      meta: 'ずっと繰り返す',
    },
    {
      word: 'if(){\n}\n',
      value: 'if(){\n}\n',
      meta: '分岐する',
    },

    {
      word: 'onKeyDown(() => {\n})\n',
      value: 'onKeyDown(() => {\n})\n',
      meta: 'なにかキーが押された時',
    },
    {
      word: "onKeyDown(() => {\n    if (keysDown.includes('A')) {\n    }\n})\n",
      value: '',
      meta: 'Aキーが押された時',
    },
    {
      word: "onKeyDown(() => {\n    if (keysDown.includes('UP')) {\n    }\n})\n",
      value: '',
      meta: '上むき矢印キーが押された時',
    },
    { word: 'repeat(10, () => {\n})\n', value: '', meta: '10回繰り返す' },
    { word: 'if( true ) {\n}', value: '', meta: 'もし なら' },
    { word: 'when(() => true, () => {\n})', value: '', meta: '〜のとき' },
    { word: 'document', value: '', meta: 'ドキュメント' },
    { word: 'block1', value: '', meta: 'id' },
    {
      word: 'every(50, "miliseconds", () => {\n})',
      value: '',
      meta: 'ループ',
    },
    { word: 'getAttribute', value: 'getAttribute', meta: '属性を取得する' },
    { word: 'setAttribute', value: 'setAttribute', meta: '属性を設定する' },
    { word: 'position', value: 'position', meta: '位置を表す属性値' },
    { word: 'rotation', value: 'rotation', meta: '回転を表す属性値' },
    { word: 'color', value: 'color', meta: '色を表す属性値' },
    { word: 'a-box', value: 'a-box', meta: '直方体' },
    { word: 'a-sphere', value: 'a-sphere', meta: '球体' },
    { word: 'random', value: 'random', meta: 'ランダム' },
    { word: 'createElement', value: 'createElement', meta: '要素を作成' },
    { word: 'tryangle', value: 'tryangle', meta: '三角形' },
    { word: 'scale', value: 'scale', meta: 'サイズ' },
    { word: 'append', value: 'append', meta: '追加' },
    { word: 'let', value: 'let', meta: '変数定義' },
    { word: 'red', value: 'red', meta: '赤' },
    { word: 'blue', value: 'blue', meta: '青' },
    { word: 'yellow', value: 'yellow', meta: '黄色' },
    { word: 'green', value: 'green', meta: '緑色' },
    { word: 'black', value: 'black', meta: '黒' },
    { word: 'white', value: 'white', meta: '白' },
    { word: 'BV', value: 'BV', meta: 'BLOCKVROCKヘルパー' },
    { word: 'get', value: 'get', meta: 'document.querySelectorのエイリアス' },
    { word: 'parallelMove', value: 'parallelMove', meta: '対象を並行移動した位置を取得' },
    { word: 'on', value: 'on', meta: 'イベントリスナーのエイリアス' },
    { word: 'onKeyDown', value: 'onKeyDown', meta: 'KeyDownイベントのリスナー' },
  ];
};
